import { gql, useQuery } from '@apollo/client';

import { useOrganizationAudience_getGroups } from './graphql-types/useOrganizationAudience_getGroups';

const AUDIENCE_QUERY = gql`
  query useOrganizationAudience_getGroups {
    groupsVisibleToReadOnlyUsers(input: {}) {
      results {
        _id
        name
        totalMembers
        isGlobalSingleton
      }
    }
  }
`;

export const useAudience = (): {
  loading: boolean;
  audiences: { _id: string; name: string; totalMembers: number }[] | undefined;
} => {
  const { data, loading } =
    useQuery<useOrganizationAudience_getGroups>(AUDIENCE_QUERY);

  return {
    loading,
    audiences:
      data?.groupsVisibleToReadOnlyUsers.results?.slice().sort((a, b) => {
        if (a.isGlobalSingleton) {
          return -1;
        }
        if (b.isGlobalSingleton) {
          return 1;
        }
        return a.name < b.name ? -1 : 1;
      }) ?? undefined,
  };
};
